<template>
  <v-data-table
    :headers="headers"
    :items="articles"
    disable-pagination
    v-model="selected"
    :show-select="!!(articles && articles.length)"
    :single-select="false"
    item-key="_uniqID"
    hide-default-footer
    class="create-lead-articles-table"
  >
    <template v-slot:header.price="{ header }">
      <div class="text-no-wrap">
        <span>{{ header.text }}</span>
        <v-tooltip right content-class="table-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" dark v-bind="attrs" v-on="on">
              mdi-alert-circle-outline
            </v-icon>
          </template>
          <span>{{ mess["price_tooltip"] }}</span>
        </v-tooltip>
      </div>
    </template>
    <template v-slot:item.code="{ item }">
      <div style="max-width: 150px">
        <span v-if="!item.unrecognized">{{ item.code }}</span>
        <span
          v-else
          :title="
            item.requested_article && item.requested_article.length > 12
              ? item.requested_article
              : ''
          "
          style="white-space: nowrap; font-size: 11px; line-height: 1.4; display: flex; flex-direction: column"
        >
          {{ mess["dialog_create_lead_unrecognized_article_title"] }}<br />
          <b>{{
            item.requested_article && item.requested_article.length > 12
              ? `${item.requested_article.slice(0, 12)}...`
              : item.requested_article
          }}</b>
        </span>
      </div>
    </template>
    <template v-slot:item.oem="{ item }">
      <div style="max-width: 150px">
        <span v-if="!item.unrecognized">{{ item.oem }}</span>
        <v-text-field
          v-else
          style="font-size: 12px; color: #000"
          hide-details
          outlined
          dense
          v-model="item.oem"
        ></v-text-field>
      </div>
    </template>
    <template v-slot:item.name="{ item }">
      <a v-if="!item.unrecognized" class="" :href="item.link" target="_blank">{{
        item.name
      }}</a>
      <v-text-field
        v-else
        style="font-size: 12px; color: #000;"
        hide-details
        outlined
        dense
        v-model="item.name"
      ></v-text-field>
    </template>
    <template v-slot:item.icons="{ item }">
      <article-icons
        :is-kit="item.isKit"
        :is-analog="item.isAnalog"
        :have-on-storage="item.haveOnStorage"
        :have-analog-on-storage="item.haveAnalogOnStorage"
        :in-transit="item.inTransit"
        :sales-draw="item.salesDraw"
        :with-file="item.isFile"
        :reference="!!item.reference.length"
      >
      </article-icons>
    </template>
    <template v-slot:item.available="{ item }">
      <available-list
        :loading="availableListLoading"
        :available="item.available"
        :transit="item.transit"
        :stores="item.market_area_items"
        :marketArea="marketArea"
      />
    </template>
    <template v-slot:item.shippingEstimate="{ item }">
      <shipping-estimate
        :item="item"
        :market-area="marketArea"
      />
    </template>
    <template v-slot:item.price="{ item }">
      <span style="white-space: nowrap">{{ item.price }}</span>
    </template>
    <template v-slot:item.second_price="{ item }">
      <span v-if="priceType.isSecondPrice" style="white-space: nowrap">{{
        item["second_price"]
      }}</span>
    </template>
    <template v-slot:item.qty="{ item }">
      <button-counter-deprecated :item="item"></button-counter-deprecated>
    </template>
    <template v-slot:item.remove="{ item }">
      <div class="d-flex">
        <v-btn
          color="primary"
          :title="mess.dialog_base_add_to_cart"
          icon
          @click="$emit('add-to-cart:article', item)"
        >
          <v-icon size="20">
            mdi-cart-plus
          </v-icon>
        </v-btn>
        <v-btn
          color="primary"
          :title="mess.dialog_base_button_remove"
          icon
          @click="$emit('remove:article', item)"
        >
          <v-icon>
            mdi-delete-forever-outline
          </v-icon>
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
// Components
import ButtonCounterDeprecated from "@/components/ButtonCounterDeprecated";
import ArticleIcons from "@/components/ArticleIcons";
import AvailableList from "@/components/AvailableList/AvailableList";
import ShippingEstimate from "@/components/ShippingEstimate";

export default {
  name: "createLeadArticlesSearchTable",
  components: {
    ArticleIcons,
    ButtonCounterDeprecated,
    AvailableList,
    ShippingEstimate
  },
  props: {
    articles: {
      type: Array,
      default: () => []
    },
    selectedArticles: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    availableListLoading: {
      type: Boolean,
      default: false
    },
    marketArea: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: []
    };
  },
  watch: {
    selectedArticles: {
      handler(val) {
        this.selected = val;
      },
      immediate: true
    },
    selected(val) {
      this.$emit("update:selected", val);
    }
  }
};
</script>
